import {computed, inject, Injectable, signal} from '@angular/core';
import {RoleCheckService} from './role-check.service';
import {UserStateService} from './user-state.service';

@Injectable({
  providedIn: 'root',
})
export class UserContractService {
  private readonly userStateService = inject(UserStateService);
  private readonly roleCheckService = inject(RoleCheckService);

  private readonly _hasActiveContract = signal<boolean | undefined>(undefined);
  readonly hasActiveContract = this._hasActiveContract.asReadonly();

  private readonly _isLoading = signal<boolean>(false);
  readonly isLoading = this._isLoading.asReadonly();

  readonly isContractCheckRequired = computed(() => {
    return (
      this.roleCheckService.hasCustomerUserRole() || this.roleCheckService.hasCustomerAdminRole()
    );
  });

  async fetchContractStatus(): Promise<void> {
    if (!this.isContractCheckRequired()) {
      this._hasActiveContract.set(true);
      return;
    }

    if (this._hasActiveContract() !== undefined) {
      return;
    }

    this._isLoading.set(true);

    try {
      const user = this.userStateService.currentUser();

      if (this.userStateService.isCustomerUserType(user)) {
        this._hasActiveContract.set(user.hasActiveContract);
      } else {
        this._hasActiveContract.set(true);
      }
    } catch (error) {
      console.error('Error fetching contract status:', error);
      this._hasActiveContract.set(false);
    } finally {
      this._isLoading.set(false);
    }
  }
}
